import { useQuery } from "@tanstack/react-query";
import { fetchHubspotClientDetail, fetchHubspotClients } from "./hubspotClients";

export async function fetchClients() {
  return fetchHubspotClients();
}

export async function fetchClientDetail(id: string) {
  return fetchHubspotClientDetail(id);
}

export function useClients() {
  return useQuery({ queryKey: ["clients"], queryFn: fetchClients, staleTime: 60_000 });
}

export function useClientDetail(id: string | undefined) {
  return useQuery({
    queryKey: ["client", id],
    queryFn: () => fetchClientDetail(id as string),
    enabled: Boolean(id),
    staleTime: 60_000,
  });
}
